import { Link } from "react-router-dom";
import { useApi } from "@/hooks/useApi";
import type { Category } from "@/lib/types";
import { Skeleton } from "@/components/base/Skeleton";
import BizMiniMap from "./BizMiniMap";

function chipColor(color?: string): string {
  if (!color) return "var(--secondary-500)";
  return color;
}

export default function BizmapPreview() {
  const { data: categories, loading } = useApi<Category[]>("categories.php");
  const chips = (categories ?? []).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-16">
      <div className="mx-auto max-w-6xl">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              민들레 비즈맵
            </h2>
            <p className="mt-2 text-foreground-600">
              회원 사업장을 지도에서 한눈에 찾아보세요.
            </p>
          </div>
          <Link
            to="/bizmap"
            className="hidden sm:inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-5 py-2.5 text-sm font-semibold text-primary-700 hover:bg-primary-100 transition-colors"
          >
            지도로 보기
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* 실제 미니 지도 카드 — 클릭하면 /bizmap 으로 이동 */}
          <div className="lg:col-span-2 overflow-hidden rounded-xl border border-background-200 bg-background-50">
            <BizMiniMap />
          </div>

          {/* 업종 칩 */}
          <div className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-6 flex flex-col">
            <h3 className="font-heading font-semibold text-foreground-800 mb-4">
              업종별 찾기
            </h3>
            {loading ? (
              <div className="flex flex-wrap gap-2">
                {Array.from({ length: 6 }).map((_, i) => (
                  <Skeleton key={i} className="h-8 w-20 rounded-full" />
                ))}
              </div>
            ) : chips.length === 0 ? (
              <p className="text-sm text-foreground-500">등록된 업종이 없습니다.</p>
            ) : (
              <div className="flex flex-wrap gap-2">
                {chips.map((c) => (
                  <Link
                    key={c.code}
                    to={`/bizmap?cate=${c.code}`}
                    className="whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium text-foreground-950 hover:opacity-80 transition-opacity"
                    style={{ backgroundColor: chipColor(c.color) }}
                  >
                    {c.name}
                    {typeof c.cnt === "number" ? ` ${c.cnt}` : ""}
                  </Link>
                ))}
              </div>
            )}
            <div className="mt-auto pt-5">
              <Link
                to="/bizmap"
                className="sm:hidden inline-flex w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-5 py-2.5 text-sm font-semibold text-primary-700"
              >
                지도로 보기
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}